import { ProductImage } from 'components/products/ProductImage';
import { CardBackground, Skeleton } from 'components/ui';
import { useAppSelector } from 'store';
import { composableFiltersState } from 'store/composableFiltersSlice';
import { useGetCustomerStatisticsQuery } from 'store/services/segmentsApi';
import { userDetailsState } from 'store/userDetailsSlice';

export default function MostPurchasedProducts() {
  const {
    output: { filtersApiPayload },
  } = useAppSelector(composableFiltersState);

  const { currentStore } = useAppSelector(userDetailsState);

  const {
    data,
    isFetching: loading,
    isError,
  } = useGetCustomerStatisticsQuery(
    {
      body: filtersApiPayload,
      params: {
        metric_list: ['top_product'],
        store_name: String(currentStore.completeInfo?.store_name),
      },
    },
    { skip: !!!currentStore.completeInfo?.store_name }
  );

  if (isError) return null;
  return (
    <section className="mt-7 md:mt-16">
      <h4 className="text-base tracking-wide md:text-2xl ">
        Most purchased products
      </h4>
      <div className="mt-2 -mx-segments-10px md:mx-0 md:mt-6">
        <CardBackground>
          <div className="p-10">
            <div className="space-y-5 md:grid md:grid-cols-3 md:grid-rows-3 gap-y-8 gap-x-8 md:space-y-0">
              {loading
                ? Array.from({ length: 12 }, (_, i) => i).map((_, index) => (
                    <LoadingTiles key={index} />
                  ))
                : data?.top_product
                    ?.slice(0, 12)
                    .map((image, index) => (
                      <ProductTiles data={image} key={index} />
                    ))}
            </div>
          </div>
        </CardBackground>
      </div>
    </section>
  );
}

/**
 *
 * @param {{data: import('store/services/types').TopProducts }} data
 */
function ProductTiles({ data }) {
  return (
    <div className="flex items-center space-x-7">
      <ProductImage
        productId={data.id}
        alt={data.title}
        className="object-contain w-16 h-16 bg-white rounded-lg"
      />
      <div>
        <p className="text-base">{data.title}</p>
        <p className="text-black text-opacity-50 text-segments-13px">
          {data.value.toLocaleString()} orders
        </p>
      </div>
    </div>
  );
}
function LoadingTiles() {
  return (
    <div className="flex items-center space-x-7">
      <Skeleton isLoaded={false}>
        <div className="w-16 h-16 rounded-lg" />
      </Skeleton>
      <div className="truncate">
        <Skeleton isLoaded={false}>
          <p className="text-base truncate">
            Lorem ipsum dolor sit amet consectetur
          </p>
        </Skeleton>
        <Skeleton isLoaded={false}>
          <p className="mt-1 text-black text-opacity-50 text-segments-13px">
            loading orders
          </p>
        </Skeleton>
      </div>
    </div>
  );
}
